(function () {
    'use strict';

    function loadIframelyEmbedJs() {
        if (document.querySelectorAll("[data-iframely-url]").length === 0 &&
            document.querySelectorAll("iframe[src*='iframe.ly']").length === 0) {
            return;
        }

        var iframely = window.iframely = window.iframely || {};
        var widgets = iframely.widgets = iframely.widgets || {};

        if (widgets.load) {
            widgets.load();
        } else {
            var ifs = document.createElement('script'); ifs.type = 'text/javascript'; ifs.async = true;
            ifs.src = 'https://cdn.iframe.ly/embed.js';
            var s = document.getElementsByTagName('script')[0]; s.parentNode.insertBefore(ifs, s);
        }
    }

    // Run after DOM ready.
    $(loadIframelyEmbedJs);
}) ();
